import React from 'react'
import { BodyMovin, Div, H1, P } from '@driftt/tide-core-legacy'
import DIZZY_BOT from './dizzy-bot-404.json'

import './style.styl'

const BODYMOVIN_OPTIONS = {
  loop: true,
  autoplay: true,
  prerender: true,
  renderer: 'svg',
  animationData: DIZZY_BOT
}

const NotFoundPage = () => (
  <Div className="not-found-page">
  <Div className="not-found-animation">
    <BodyMovin options={BODYMOVIN_OPTIONS} />
  </Div>
    <H1 className="not-found-header">Oh man, you stumped DriftBot!</H1>
    <P className="not-found-subtext">We can’t seem to find what you’re looking for…maybe it’s time for a reboot 🙈</P>
  </Div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/scripts/components/NotFoundPage/index.js